import { Box } from '@mui/material';
import styled from 'styled-components';
import { Typography, colors } from '@leapeasy/ui-kit';
import { getDemoData } from 'utils/helpers';
import { DetailsCard } from 'elements/DetailsCard';

export const RiderDetails = ({ application, isDemo }) => {
  return (
    <Box display="flex" flexDirection="column" gap="10px" padding="24px">
      <Typography variant="h4" style={{ color: colors.purple[900] }}>
        Rider Details
      </Typography>

      <Box display="flex" flexDirection="column" gap="8px">
        <LowContainer>
          <DetailsCard
            title="Policy ID"
            value={application.rider_id ? application.rider_id : 'No Data'}
          />
          <DetailsCard
            title="Bond Issue Date"
            value={application.issue_date ? application.issue_date : 'No Data'}
          />
          <DetailsCard
            title="LDR Coverage"
            value={application.ldr_coverage ? application.ldr_coverage : 'No Data'}
          />
          <DetailsCard
            title="Total Coverage Amount"
            value={
              application.total_coverage_amount
                ? '$' +
                  (application.total_coverage_amount
                    ? parseFloat(application.total_coverage_amount).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
          />
          <DetailsCard
            title="Revised Unit Number"
            value={application.revised_unit_number ? application.revised_unit_number : 'No Data'}
          />
          <DetailsCard
            title="Lease Start Date"
            value={application.lease_start_date ? application.lease_start_date : 'No Data'}
          />
        </LowContainer>

        <LowContainer>
          <DetailsCard
            title="Lease End Date"
            value={application.lease_end_date ? application.lease_end_date : 'No Data'}
          />
          <DetailsCard
            title="Coverage Start Date"
            value={application.coverage_start_date ? application.coverage_start_date : 'No Data'}
          />
          <DetailsCard
            title="Coverage End Date"
            value={application.coverage_end_date ? application.coverage_end_date : 'No Data'}
          />
          <DetailsCard
            title="Gross Monthly Rent"
            value={
              application.gross_monthly_rent
                ? '$' +
                  (application.gross_monthly_rent
                    ? parseFloat(application.gross_monthly_rent).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
          />
          <DetailsCard
            title="Gross Annual Rent"
            value={
              application.gross_annual_rent
                ? '$' +
                  (application.gross_annual_rent
                    ? parseFloat(application.gross_annual_rent).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
          />
          <DetailsCard
            title="Total Number of Residents"
            value={
              application.total_number_of_tenants
                ? application.total_number_of_tenants
                  ? parseInt(application.total_number_of_tenants, 10).toLocaleString('en-US')
                  : 0
                : 'No Data'
            }
          />
        </LowContainer>
        <LowContainer>
          <DetailsCard
            title="Damage Coverage"
            value={
              application.damages_premium
                ? '$' +
                  (application.damages_premium
                    ? parseFloat(application.damages_premium).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
          />
          <DetailsCard
            title="Operator Account"
            value={
              isDemo
                ? getDemoData('landlord-name')
                : application.lanlord_account_name
                  ? application.lanlord_account_name
                  : 'No Data'
            }
          />
          <DetailsCard
            title="Property Account"
            value={
              isDemo
                ? getDemoData('building-name')
                : application.apartment_building_name
                  ? application.apartment_building_name
                  : 'No Data'
            }
          />
          <DetailsCard
            title="Coverage Requested /mo"
            value={
              application.coverage_amount_requested_months
                ? parseInt(application.coverage_amount_requested_months, 10)
                : 'No Data'
            }
          />

          <Box width="16.6%" flexShrink={1} />
          <Box width="16.6%" flexShrink={1} />
        </LowContainer>
      </Box>
    </Box>
  );
};

const LowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  & > div {
    width: 100%;
  }

  @media screen and (max-width: ${(props) => props.theme.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: ${(props) => props.theme.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
